import { BookingContinueButton } from "./BookingContinueButton";
import { withDisableButtonOnQuery } from "../../withDisableButtonOnQuery";

export default withDisableButtonOnQuery(BookingContinueButton);
